/**
 * Creates a url for a specific help article page.
 *
 * @param {number} articleId
 */
export const createArticleUrl = (articleId) => `/article/${articleId}`;

/**
 * Creates a url for a specific help topic page.
 *
 * @param {number} topicId
 */
export const createTopicUrl = (topicId) => `/topic/${topicId}`;

/**
 * Creates a url for a the general help topics page.
 */
export const createTopicsUrl = () => `/topics`;

/**
 * Creates a url for the help center page.
 */
export const createHelpCenterUrl = () => `/helpcenter`;

/**
 * Creates a url for a breadcrumb node.
 *
 * @param {any} nodeData
 */
export const createBreadcrumbUrl = (nodeData = {}) => {
  const { articleId, topicId } = nodeData;
  if (articleId) {
    return createArticleUrl(articleId);
  }
  else if (topicId) {
    return createTopicUrl(topicId);
  }
  else {
    return createHelpCenterUrl();
  }
};

/**
 * Creates breadcrumb data for an article.
 *
 * @param {any} topicsTree Topics tree structure.
 * @param {number} articleId The article id.
 *
 * @public
*/
export const createArticleBreadcrumbs = (topicsTree, articleId) => {
  if (!articleId) return [];

  let path = [];
  let topic = topicsTree.find(n => (n.children?.some(c => c.articleId === articleId)));

  if (topic) {
    const article = topic.children.find(n => n.articleId === articleId);
    const { title, topicId } = article;

    path = [{ title, topicId, articleId }];
    topic = topicsTree.find(n => n.topicId === article.topicId);

    while (topic) {
      const { title, topicId, parentTopicId } = topic;

      path = [{ title, topicId }, ...path];
      topic = topicsTree.find(n => n.topicId === parentTopicId);
    };
  }

  return path;
};

/**
 * Creates breadcrumb data for a topic.
 *
 * @param {any} topicsTree Topics tree structure.
 * @param {number} articleId The article id.
 *
 * @public
*/
export const createTopicBreadcrumbs = (topicsTree, topicId) => {
  if (!topicId) return [];

  let path = [];
  let topic = topicsTree.find(n => n.topicId === topicId);

  while (topic) {
    path = [
      {
        title: topic.title,
        topicId: topic.topicId,
      },
      ...path,
    ];
    topic = topicsTree.find(n => n.topicId === topic.parentTopicId);
  };

  return path;
};
